<div class="notification-outer">
  <div class="close" (click)="close()">
    <i class="material-icons">close</i>
  </div>
  <div class="wrapper">
    <svg class="balloon" height="73" width="56" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-label="RE/Max Balloon">
      <image x="0" y="0" height="73" width="56" attr.xlink:href="{{'/assets/BalloonLarge.svg' | staticp }}"/>
    </svg>
    <div class="inner-content">
      <div class="is-flex centered title">
        <div class="sent">
          <b>{{title}}</b>
        </div>
      </div>
      <div class="message-content text-center">
        {{messageText}}
      </div>
    </div>
  </div>
</div>
